'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _extends = require('@babel/runtime/helpers/extends');
var _defineProperty = require('@babel/runtime/helpers/defineProperty');
var _taggedTemplateLiteralLoose = require('@babel/runtime/helpers/taggedTemplateLiteralLoose');
var React = require('react');
var reduxForm = require('redux-form');
var formik = require('formik');
var bumbag = require('bumbag');
var reactPaymentInputs = require('react-payment-inputs');
var validator = require('react-payment-inputs/lib/utils/validator');
var faCreditCard = require('@fortawesome/pro-regular-svg-icons/faCreditCard');
var faCalendarAlt = require('@fortawesome/pro-regular-svg-icons/faCalendarAlt');
var faLockAlt = require('@fortawesome/pro-regular-svg-icons/faLockAlt');
var mastercard = require('@medipass/assets/images/mastercard.svg');
var visa = require('@medipass/assets/images/visa.svg');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var _defineProperty__default = /*#__PURE__*/_interopDefaultLegacy(_defineProperty);
var _taggedTemplateLiteralLoose__default = /*#__PURE__*/_interopDefaultLegacy(_taggedTemplateLiteralLoose);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var mastercard__default = /*#__PURE__*/_interopDefaultLegacy(mastercard);
var visa__default = /*#__PURE__*/_interopDefaultLegacy(visa);

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty__default["default"](target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var StyledIcon = bumbag.styled(bumbag.Input.Icon)(_templateObject || (_templateObject = _taggedTemplateLiteralLoose__default["default"](["\n  ", ";\n"])), function (props) {
  return (// @ts-expect-error TS(2339): Property 'size' does not exist on type 'BoxOptions... Remove this comment to see the full error message
    props.size === 'large' && bumbag.css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose__default["default"](["\n      &&& {\n        font-size: 20px;\n        height: 66px;\n      }\n    "])))
  );
});
var InputField = bumbag.styled(bumbag.InputField)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose__default["default"](["\n  & input {\n    ", ";\n  }\n"])), function (props) {
  return props.size === 'large' && bumbag.css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteralLoose__default["default"](["\n        height: 66px;\n        padding-left: 2em;\n      "])));
}); // @ts-expect-error TS(7006): Parameter 'props' implicitly has an 'any' type.

function getError(props) {
  var error;

  if (props.meta) {
    error = props.meta.touched && props.meta.error;
  }

  if (props.form && props.form.errors) {
    error = props.form.touched[props.field.name] && props.form.errors[props.field.name];
  }

  return error;
} // @ts-expect-error TS(7006): Parameter 'props' implicitly has an 'any' type.


function getHandlers(props) {
  var handlers = {};

  if (props.input) {
    handlers = {
      onBlur: props.input.onBlur,
      onChange: props.input.onChange
    };
  }

  if (props.field) {
    handlers = {
      onBlur: props.field.onBlur,
      onChange: props.field.onChange
    };
  }

  return handlers;
}

PaymentCardInputs.defaultProps = {
  isAutoCompleteEnabled: true,
  isRequired: false,
  expiryValidator: undefined,
  size: 'default',
  variant: 'default'
};

function PaymentCardInputs(props) {
  var isAutoCompleteEnabled = props.isAutoCompleteEnabled,
      isRequired = props.isRequired,
      formType = props.formType,
      expiryValidator = props.expiryValidator,
      size = props.size,
      variant = props.variant;
  var cardNumberValidator = React__default["default"].useCallback(function (_ref) {
    _ref.cardNumber;
        var cardType = _ref.cardType;
        _ref.errorMessages;

    if (cardType.displayName === 'Visa' || cardType.displayName === 'Mastercard') {
      return;
    }

    return 'Card must be Visa or Mastercard';
  }, []);
  var isMobile = bumbag.useBreakpoint('mobile');

  var _usePaymentInputs = reactPaymentInputs.usePaymentInputs(_objectSpread({
    autoFocus: false
  }, cardNumberValidator && {
    cardNumberValidator: cardNumberValidator
  }, {}, expiryValidator && {
    expiryValidator: expiryValidator
  })),
      meta = _usePaymentInputs.meta,
      getCardNumberProps = _usePaymentInputs.getCardNumberProps,
      getExpiryDateProps = _usePaymentInputs.getExpiryDateProps,
      getCVCProps = _usePaymentInputs.getCVCProps;

  function getCardLogo() {
    var _meta$cardType, _meta$cardType2;

    if ((meta == null ? void 0 : (_meta$cardType = meta.cardType) == null ? void 0 : _meta$cardType.type) === 'visa') {
      return /*#__PURE__*/React__default["default"].createElement("img", {
        src: visa__default["default"],
        className: "absolute -top-2 right-0 h-6",
        alt: "visa credit card"
      });
    }

    if ((meta == null ? void 0 : (_meta$cardType2 = meta.cardType) == null ? void 0 : _meta$cardType2.type) === 'mastercard') {
      return /*#__PURE__*/React__default["default"].createElement("img", {
        src: mastercard__default["default"],
        className: "absolute -top-2 right-0 h-6",
        alt: "mastecard credit card"
      });
    }

    return null;
  }

  var CardNumberField = React__default["default"].useCallback(function (props) {
    return /*#__PURE__*/React__default["default"].createElement(InputField, _extends__default["default"]({
      autoComplete: "off" // @ts-expect-error TS(2322): Type '{ icon: IconDefinition; color: "gray700"; ty... Remove this comment to see the full error message
      ,
      before: /*#__PURE__*/React__default["default"].createElement(StyledIcon, {
        icon: faCreditCard.faCreditCard,
        color: "gray700",
        type: "font-awesome",
        size: size
      }),
      label: "Card number",
      size: size,
      state: getError(props) ? 'danger' : undefined // @ts-expect-error TS(2339): Property 'showErrorMessage' does not exist on type... Remove this comment to see the full error message
      // eslint-disable-line
      ,
      validationText: props.showErrorMessage ? getError(props) : undefined
    }, getCardNumberProps(_objectSpread({
      refKey: 'inputRef',
      type: isAutoCompleteEnabled ? 'tel' : 'search',
      autoComplete: isAutoCompleteEnabled ? 'cc-number' : 'off',
      placeholder: ''
    }, props, {}, getHandlers(props)))));
  }, [getCardNumberProps, isAutoCompleteEnabled, size]);
  var ExpiryField = React__default["default"].useCallback(function (props) {
    return /*#__PURE__*/React__default["default"].createElement(InputField, _extends__default["default"]({
      autoComplete: "off" // @ts-expect-error TS(2322): Type '{ icon: IconDefinition; color: "gray700"; ty... Remove this comment to see the full error message
      ,
      before: /*#__PURE__*/React__default["default"].createElement(StyledIcon, {
        icon: faCalendarAlt.faCalendarAlt,
        color: "gray700",
        type: "font-awesome",
        size: size
      }),
      label: "Expiry",
      size: size,
      state: getError(props) ? 'danger' : undefined,
      validationText: props.showErrorMessage ? getError(props) : undefined
    }, getExpiryDateProps(_objectSpread({
      refKey: 'inputRef',
      name: 'expiry',
      autoComplete: isAutoCompleteEnabled ? 'cc-exp' : 'off'
    }, props, {}, getHandlers(props)))));
  }, [getExpiryDateProps, isAutoCompleteEnabled, size]);
  var CVCField = React__default["default"].useCallback(function (props) {
    return /*#__PURE__*/React__default["default"].createElement(InputField, _extends__default["default"]({
      autoComplete: "off" // @ts-expect-error TS(2322): Type '{ icon: IconDefinition; color: "gray700"; ty... Remove this comment to see the full error message
      ,
      before: /*#__PURE__*/React__default["default"].createElement(StyledIcon, {
        icon: faLockAlt.faLockAlt,
        color: "gray700",
        type: "font-awesome",
        size: size
      }),
      label: "CVC",
      size: size,
      state: getError(props) ? 'danger' : undefined,
      validationText: props.showErrorMessage ? getError(props) : undefined
    }, getCVCProps(_objectSpread({
      refKey: 'inputRef',
      placeholder: '',
      autoComplete: isAutoCompleteEnabled ? 'cc-csc' : 'off'
    }, props, {}, getHandlers(props)))));
  }, [getCVCProps, isAutoCompleteEnabled, size]);
  var validateCardNumber = React__default["default"].useCallback(function (value) {
    if (!isRequired && !value) {
      return undefined;
    }

    return validator.getCardNumberError(value, cardNumberValidator);
  }, [cardNumberValidator, isRequired]);
  var validateExpiry = React__default["default"].useCallback(function (value) {
    if (!isRequired && !value) {
      return undefined;
    }

    return validator.getExpiryDateError(value, expiryValidator);
  }, [expiryValidator, isRequired]);
  var validateCVC = React__default["default"].useCallback(function (value) {
    if (!isRequired && !value) {
      return undefined;
    }

    return validator.getCVCError(value);
  }, [isRequired]);
  var Field = reduxForm.Field;

  if (formType === 'redux-form') {
    Field = reduxForm.Field;
  }

  if (formType === 'formik') {
    // @ts-expect-error
    Field = formik.Field;
  }

  return /*#__PURE__*/React__default["default"].createElement(bumbag.Box, null, isMobile || variant === 'wrapped' ? /*#__PURE__*/React__default["default"].createElement(bumbag.FieldStack, null, /*#__PURE__*/React__default["default"].createElement("div", {
    className: "relative"
  }, getCardLogo()), /*#__PURE__*/React__default["default"].createElement(Field, {
    name: "cardNumber",
    component: CardNumberField,
    flex: "3",
    showErrorMessage: true,
    validate: validateCardNumber
  }), /*#__PURE__*/React__default["default"].createElement(bumbag.Flex, {
    isHorizontal: true,
    spacing: "major-1"
  }, /*#__PURE__*/React__default["default"].createElement(Field, {
    name: "expiry",
    component: ExpiryField,
    flex: "1",
    marginRight: "major-1",
    showErrorMessage: true,
    validate: validateExpiry
  }), /*#__PURE__*/React__default["default"].createElement(Field, {
    name: "cvc",
    component: CVCField,
    flex: "1",
    showErrorMessage: true,
    validate: validateCVC
  }))) : /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement(bumbag.Flex, null, /*#__PURE__*/React__default["default"].createElement(Field, {
    name: "cardNumber",
    component: CardNumberField,
    flex: "5",
    marginRight: "major-1",
    validate: validateCardNumber
  }), /*#__PURE__*/React__default["default"].createElement(Field, {
    name: "expiry",
    component: ExpiryField,
    flex: "3",
    marginRight: "major-1",
    validate: validateExpiry
  }), /*#__PURE__*/React__default["default"].createElement(Field, {
    name: "cvc",
    component: CVCField,
    flex: "2",
    validate: validateCVC
  })), /*#__PURE__*/React__default["default"].createElement(bumbag.Text, {
    color: "danger",
    fontSize: "150"
  }, meta.isTouched && meta.error)));
}

exports["default"] = PaymentCardInputs;
